
//const siteURL = 'http://localhost:8811/api/';
//const siteURL ="http://208.109.53.27:8810/api/";
 const siteURL ="https://apimy.panelreward.com/api/"
//const siteURL = 'https://gnnapi.panelreward.com/api/';
//const imageUrl = 'http://localhost:8811';
 //const imageUrl =   'https://gnnapi.panelreward.com';
const imageUrl =   'https://apimy.panelreward.com';
//const imageUrl =   'http://208.109.53.27:8811';

  let appConfig = {
    siteURL : siteURL,
    imageUrl : imageUrl
    //headers: headers
  }
  export default appConfig



// WEBPACK FOOTER //
// ./src/api/apiConfig.js